import {
  tenDlcPhoneRegistrationMetric,
  tenDlcStatusMetric,
} from '../../handoff-metrics/metrics/ten-dlc';
import { UnifyMetricDefinition } from '../unify-metrics.types';
import { adaptHandoffMetric } from './adapt-handoff-metric';

export const tenDlcMetricDef: UnifyMetricDefinition = {
  id: '10_dlc_status',
  name: '10 DLC Status',
  sectionName: '10 DLC',
  allowExceptions: true,
  criteria: [
    adaptHandoffMetric(tenDlcStatusMetric),
    adaptHandoffMetric(tenDlcPhoneRegistrationMetric),
  ],
};
